import {$api} from "../../../api/api";
import $axios from "../../../api/axiosAccessor";

export const getNotificationsList = async () => {
    return await $axios.get($api("notifications_list"));
};

export const getNotificationDetails = async (id) => {
    return await $axios.get($api("notifications_details", {id}));
};

export const getNotificationsStats = async () => {
    return await $axios.get($api("notifications_stats"));
};

export const postNotificationsMarkedRead = async (payload) => {
    return await $axios.post($api("notifications_mark_read"), payload);
};

export const postNotificationsMarkedReadAll = async () => {
    return await $axios.post($api("notifications_mark_all_read"));
};

export const getNotificationsUnreadCount = async () => {
    return await $axios.get($api("notifications_stats"));
};
